







import Component from "vue-class-component";
import Vue from "vue";
import QueryFilter from "@/components/QueryFilter.vue";
import { DateRangePickerValue, FormFields, FormValues } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";
import DateRangePicker from "@/components/DateRangePicker";

@Component({
  name: "TransactionsFilter",
  components: { DateRangePicker, QueryFilter },
})
export default class TransactionsFilter extends Vue {
  public fields: FormFields = [
    {
      name: "term",
      title: $t("Quick Search"),
      flexClass: "px-6 col-12 col-md-4",
      placeholder: $t("Put here ID, name"),
      clearable: true,
    },
    {
      name: "type",
      title: $t("Show"),
      flexClass: "px-6 col-12 col-sm-6 col-md-4",
      type: "select",
      clearable: false,
      list: [
        {
          text: $t("All transactions"),
          value: null,
        },
        {
          text: $t("DEPOSIT"),
          value: "DEPOSIT",
        },
        {
          text: $t("SPENDING"),
          value: "SPENDING",
        },
        {
          text: $t("EARNING"),
          value: "EARNING",
        },
        {
          text: $t("MANUAL"),
          value: "MANUAL",
        },
        {
          text: $t("PAYOUT"),
          value: "PAYOUT",
        },
        {
          text: $t("REFUND"),
          value: "REFUND",
        },
        {
          text: $t("CHARGEBACK"),
          value: "CHARGEBACK",
        },
      ],
    },
    {
      name: "dateFromTo",
      title: $t("Date"),
      flexClass: "px-6 col-12 col-sm-6 col-md-4",
      type: "dateRange",
      inputHandler: this.setValue,
    },
  ];

  public setValue(payload: DateRangePickerValue, values: FormValues): FormValues {
    this.$set(values, "timeFrom", payload.dateStart);
    this.$set(values, "timeTo", payload.dateEnd);
    return values;
  }

  get dateValue(): DateRangePickerValue {
    const query = this.$route.query;
    const timeTo = query.timeTo ? query.timeTo.toString() : "";
    const timeFrom = query.timeFrom ? query.timeFrom.toString() : "";

    return { dateEnd: timeTo, dateStart: timeFrom };
  }
}
